module.exports = __webpack_public_path__ + "img/katarina_bathrooms_2.c752c101.jpg";